<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" viewBox="0 0 25 19">
    <g transform="translate(-1097.809 -582.567)">
      <g transform="translate(1097.809 582.567)">
        <path
          d="M1122.335,594.542h-24.526l.039-.534a42.23,42.23,0,0,1,1.557-8.671l.7.03.27-.144a5.438,5.438,0,0,0,1.316.847c.818.443,2.46-.3,3.323-.795l-1.219-2.708,1.14.38a65.556,65.556,0,0,1,6.478,2.545,27.974,27.974,0,0,0,5.34,1.563,21.078,21.078,0,0,1,4.585,1.352c2.385,1.256,1.154,5.584,1.1,5.767Zm-23.377-1h22.55c.286-1.231.551-3.61-.69-4.264a20.8,20.8,0,0,0-4.306-1.251,28.615,28.615,0,0,1-5.565-1.639c-1.692-.771-3.443-1.478-5.214-2.1l.613,1.361-.354.232c-.315.2-3.117,1.989-4.826,1.059-.4-.217-.709-.4-.947-.554a41.263,41.263,0,0,0-1.266,7.156Z"
          transform="translate(-1097.809 -582.567)"
        />
        <rect
          width="24.12"
          height="1"
          transform="translate(0.578 8.521)"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(10.5 4.949) rotate(-60.477)"
        />
        <rect
          width="2.484"
          height="1"
          transform="translate(12.744 5.673) rotate(-59.203)"
        />
      </g>
      <g transform="translate(1100.807 593.566)">
        <rect
          width="5"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1105.807,596.566h-5v-3h5Zm-4-1h3v-1h-3Z"
          transform="translate(-1100.807 -593.566)"
        />
      </g>
      <g transform="translate(1114.363 593.566)">
        <rect
          width="5"
          height="3"
          transform="translate(0 0.001)"
          fill="#fff"
        />
        <path
          d="M1117.807,596.566h-5v-3h5Zm-4-1h3v-1h-3Z"
          transform="translate(-1112.807 -593.566)"
        />
      </g>
      <g transform="translate(1100.807 597.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1101.307,600.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1101.307,600.566Z"
          transform="translate(-1100.807 -597.566)"
        />
      </g>
      <g transform="translate(1113.847 597.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1113.307,600.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1113.307,600.566Z"
          transform="translate(-1112.807 -597.566)"
        />
      </g>
      <g transform="translate(1105.292 597.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1105.307,600.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1105.307,600.566Z"
          transform="translate(-1104.807 -597.566)"
        />
      </g>
      <g transform="translate(1118.363 597.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1117.307,600.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1117.307,600.566Z"
          transform="translate(-1116.807 -597.566)"
        />
      </g>
      <g transform="translate(1103.153 598.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1103.307,601.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1103.307,601.566Z"
          transform="translate(-1102.807 -598.566)"
        />
      </g>
      <g transform="translate(1115.985 598.566)">
        <rect
          width="1"
          height="3"
          transform="translate(0 0.001)"
          fill="none"
        />
        <path
          d="M1115.307,601.566a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,1115.307,601.566Z"
          transform="translate(-1114.807 -598.566)"
        />
      </g>
    </g>
  </svg>
</template>
